export const GET_POSTS = 'GET_POSTS'
export const GET_POSTS_ERR = 'GET_POSTS_ERR'